export const OTP_TIMER_SECONDS = 60 * 15; // 15 minutes
export const MAX_RESENDS = 3;
export const MAX_OTP_LENGTH = 4;
export const OTP_PURPOSE_SIGNUP = "signup";
export const OTP_PURPOSE_FORGOT_PASSWORD = "forgot_password";
